import { createSelector } from '@ngrx/store';

export const selectWebSocketFeature = (state: any) => state.websocket;

export const selectConnectionId = createSelector(
  selectWebSocketFeature,
  (webSocketState) => webSocketState.connectionId,
);

export const selectIsConnected = createSelector(
  selectWebSocketFeature,
  (webSocketState) => webSocketState.isConnected,
);

export const selectWorkspaceId = createSelector(
  selectWebSocketFeature,
  (webSocketState) => webSocketState.workspaceId,
);
